import tableHelper from '../../helpers/tableHelper'
import roles from '../../helpers/userRoles'
import _ from 'lodash'
import { mapActions } from 'vuex'

const sortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
}

const countRowsToShow = 60

export default {
  name: 'Tasks',
  props: {
    status: {
      default: ''
    },
    isShowFilters: {
      default: false
    }
  },
  data: () => {
    return {
      searchText: '',
      lazySearchText: '',
      activeFilterName: '',
      isLoadData: false,
      countRowsToShow: countRowsToShow
    }
  },
  computed: {
    masterAllTasks () {
      return [
        ...new Set([
          ...this.$store.getters.tasksInDesign,
          ...this.$store.getters.tasksInPrint,
          ...this.$store.getters.tasksInAfterPrint
        ])
      ]
    },
    filters: function () {
      return [
        {
          name: 'all',
          viewName: this.$t('shared.all'),
          icoName: 'ico-tasks',
          tasks: this.$store.getters.role === roles.master
            ? this.masterAllTasks
            : this.$store.getters.activeTasks,
          isActive: this.activeFilterName === 'all',
          isVisible:
            this.$store.getters.role === roles.director ||
            this.$store.getters.role === roles.manager ||
            this.$store.getters.role === roles.master
        },
        {
          name: 'design',
          viewName: this.$t('shared.design'),
          icoName: 'ico-design',
          isActive: this.activeFilterName === 'design',
          tasks: this.$store.getters.tasksInDesign,
          isVisible:
            this.$store.getters.role === roles.director ||
            this.$store.getters.role === roles.manager ||
            this.$store.getters.role === roles.designer ||
            this.$store.getters.role === roles.master
        },
        {
          name: 'print',
          viewName: this.$t('shared.print'),
          icoName: 'ico-print',
          isActive: this.activeFilterName === 'print',
          tasks: this.$store.getters.tasksInPrint,
          isVisible:
            this.$store.getters.role === roles.director ||
            this.$store.getters.role === roles.manager ||
            this.$store.getters.role === roles.printer ||
            this.$store.getters.role === roles.master
        },
        {
          name: 'afterPrint',
          viewName: this.$t('shared.after_print'),
          icoName: 'ico-afterprint',
          isActive: this.activeFilterName === 'afterPrint',
          tasks: this.$store.getters.tasksInAfterPrint,
          isVisible:
            this.$store.getters.role === roles.director ||
            this.$store.getters.role === roles.manager ||
            this.$store.getters.role === roles.afterPrinter ||
            this.$store.getters.role === roles.master
        }
      ]
    },
    tableColumns: function () {
      return tableHelper.getColumns(
        this.$store.getters.role,
        this.activeFilterName
      )
    },
    formattedRows: function () {
      let tasks = []
      const rows = []
      switch (this.status) {
        case 'active':
          tasks = this.$store.getters.userActiveTasks
          break
        case 'paused':
          tasks = this.$store.getters.userPausedTasks
          break
        case 'stored':
          tasks = this.$store.getters.userStoredTasks
          break
        case 'contracted':
          tasks = this.$store.getters.userContractedTasks
          break
        default: {
          const filter = this.filters.find(x => x.isActive)
          tasks = !filter ? [] : filter.tasks
          break
        }
      }

      tasks.forEach(function (task) {
        const row = tableHelper.getRow(task, this.tableColumns)
        rows.push(row)
      }, this)

      return rows
    },
    orderedRows: function () {
      const sortFieldName = this.$store.getters.tasksSortColumn
      let sorterdRows = _.sortBy(this.formattedRows, function (row) {
        return _.find(row.cells, { sortName: sortFieldName }).sortValue
      })

      if (this.$store.getters.tasksSortDirection === sortTypes.DESC) {
        sorterdRows.reverse()
      }

      sorterdRows = _.sortBy(sorterdRows, function (row) {
        return !row.hot && !row.overdue
      })
      sorterdRows = _.sortBy(sorterdRows, function (row) {
        return !row.overdue
      })

      return sorterdRows
    },
    tableRows: function () {
      if (this.lazySearchText) {
        var filteredRows = this.orderedRows.filter(function (row) {
          return row.cells.some(function (cell) {
            return (
              cell.value
                .toString()
                .toLowerCase()
                .indexOf(this.lazySearchText.toLowerCase()) >= 0
            )
          }, this)
        }, this)
        return filteredRows
      }

      return this.orderedRows
    },
    showedRows () {
      return this.tableRows.slice(0, this.countRowsToShow)
    }
  },
  methods: {
    rowClick (taskId) {
      this.$router.push({ path: `/view-task/${taskId}` })
    },
    statusFilterSelect (name) {
      this.activeFilterName = name
    },
    columnClick (sortName) {
      const sortOptions = {
        column: sortName
      }

      if (this.$store.getters.tasksSortColumn === sortName) {
        if (this.$store.getters.tasksSortDirection === sortTypes.ASC) {
          sortOptions.direction = sortTypes.DESC
        } else {
          sortOptions.direction = sortTypes.ASC
        }
      } else {
        sortOptions.direction = sortTypes.ASC
      }
      this.saveSortOptions(sortOptions)
    },
    getActiveFilterName (status) {
      if (!status) {
        let filter = {}
        switch (this.$store.getters.role) {
          case roles.designer:
            filter = this.filters.find(x => x.name === 'design')
            break
          case roles.printer:
            filter = this.filters.find(x => x.name === 'print')
            break
          case roles.afterPrinter:
            filter = this.filters.find(x => x.name === 'afterPrint')
            break
          case roles.master:
            filter = this.filters.find(x => x.name === 'all' || x.name === 'design' || x.name === 'print' || x.name === 'afterPrint')
            break
          default:
            filter = this.filters.find(x => x.name === 'all')
            break
        }
        return filter.name
      }
    },
    loadTasksBaseOnStatus (status) {
      this.isLoadData = true
      switch (status) {
        case '':
        case 'active':
        case 'paused':
        case 'stored':
        case 'contracted':
          this.loadActiveTasks()
            .then(() => {
              this.isLoadData = false
            })
            .catch(() => {
              this.isLoadData = false
            })
          break
      }
    },
    clearSearchText () {
      this.searchText = ''
    },
    checkScroll () {
      if (document.documentElement.scrollHeight - document.documentElement.scrollTop.toFixed() - document.documentElement.clientHeight <= 10 && document.documentElement.scrollTop > 0) {
        if (this.countRowsToShow < this.tableRows.length) {
        } this.countRowsToShow += countRowsToShow
      }
    },
    ...mapActions({
      loadActiveTasks: 'LOAD_ACTIVE_TASKS',
      saveSortOptions: 'SAVE_TASKS_TABLE_SORT'
    })
  },
  watch: {
    searchText: _.debounce(function (newValue) {
      this.lazySearchText = newValue
      this.loadTasksBaseOnStatus(this.status)
    }, 300),
    tableRows: function (newValue, prevValue) {
      if (newValue.length !== prevValue.length) {
        this.countRowsToShow = countRowsToShow
      }
    },
    status: function (val) {
      this.activeFilterName = this.getActiveFilterName(val)
      this.loadTasksBaseOnStatus(val)
    }
  },
  created () {
    this.activeFilterName = this.getActiveFilterName(this.status)
    this.loadTasksBaseOnStatus(this.status)
    if (
      !this.$store.getters.tasksSortColumn ||
      !this.$store.getters.tasksSortDirection
    ) {
      this.saveSortOptions({
        column: this.tableColumns[0].sortName,
        direction: sortTypes.ASC
      })
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', _.debounce(this.checkScroll, 150))
  },
  mounted () {
    window.addEventListener('scroll', _.debounce(this.checkScroll, 150))
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'Задачи')
    })
  }
}
